import { DashboardSettingsFilters, DashboardSettingsFiltersDateInput } from "../../../__generated__/api";
import { parseFilterDates } from "../../../date";
import TicketItem from "../ticket-item";
import { FILTER_REGISTRY, Filter } from "./base";

export default class LastResponseDateFilter extends Filter {
    public static shouldCreate(filter: DashboardSettingsFilters): boolean {
        return filter.lastResponseDate != null;
    }

    private startDate: number | undefined;

    private endDate: number | undefined;

    public constructor(filter: DashboardSettingsFilters) {
        super(filter);
        const { startDate, endDate } = parseFilterDates(filter.lastResponseDate as DashboardSettingsFiltersDateInput);
        this.startDate = startDate;
        this.endDate = endDate;
    }

    public shouldInclude(ticket: TicketItem): boolean {
        const lastUserMessageDate = ticket.lastUserMessageDate?.getTime();
        if (!lastUserMessageDate) {
            return false;
        }
        return (this.startDate ? lastUserMessageDate >= this.startDate : true)
            && (this.endDate ? lastUserMessageDate <= this.endDate : true);
    }
}

FILTER_REGISTRY.register(LastResponseDateFilter);
